export enum PlayerType {
  Shaka = 'shaka',
  Bitmovin = 'bitmovin',
  HLS = 'hls',
  DASH = 'dash',
}

export type PlayerInfo = {
  name: string;
  version: string;
};

export type VideoMetadataType = {
  title?: string;
  isLive?: boolean;
  viewerId?: string;
  custom?: Record<string, string>;
};

export interface IPlayerAdapter {
  createSession: ({
    assetName,
    viewerId,
    isLive,
  }: {
    assetName: string;
    viewerId?: string;
    isLive?: boolean;
  }) => void | Promise<void>;
  destroySession: () => void;
  setPlayer: (player: any) => void;
  unsetPlayer: () => void;
  getPlayerInfo: () => PlayerInfo;
  setContentInfo: (metadata: VideoMetadataType) => void;
  sendCustomEvent: (eventName: string, attributes: Record<string, string>) => void;
  reportAppBackgrounded: () => void;
  reportAppForegrounded: () => void;
}

export enum PlatformType {
  Web = 'web',
  Tizen = 'tizen',
  WebOS = 'webos',
  Vidaa = 'vidaa',
  PS5 = 'ps5',
}

export type DeviceMetaType = {
  platform: PlatformType;
  osVersion: string;
  osName: string;
  deviceModel: string;
  brand: string;
  manufacturer: string;
  connectionType: string;
};
